import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 0D688B5D-27F8-47CF-9234-87DB3F25D28E
 * name skip-next-circle
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skip-next-circle.svg
 * tags
 */
export const SkipNextCircleIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M8,8L13,12L8,16M14,8H16V16H14" /></>, 'SkipNextCircleIcon');
export default SkipNextCircleIcon